var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.044,
    x2: 338.386,
    xlinkHref: "#lg1",
    y1: 194.211,
    y2: 326.544
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.074,
    x2: 186.083,
    xlinkHref: "#lg2",
    y1: 186.548,
    y2: 131.799
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.012,
    x2: 192.29,
    xlinkHref: "#lg1",
    y1: 134.792,
    y2: 205.432
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.991,
    x2: 126.814,
    y1: 207.206,
    y2: 295.507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.976,
    x2: 289.383,
    xlinkHref: "#lg2",
    y1: 352.212,
    y2: 296.619
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.739,
    x2: 378.017,
    xlinkHref: "#lg1",
    y1: 316.302,
    y2: 386.942
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m324.261 3.215-137.241 130.509c-11.396 10.837-3.726 30.032 12 30.032h41.532c4.51 0 7.052 5.181 4.292 8.748l-118.887 153.629c-8.856 11.444-.699 28.071 13.771 28.071h49.141c4.282 0 6.877 4.727 4.578 8.34l-79.791 125.396c-8.738 13.733 8.643 29.035 21.158 18.628l214.804-178.629c12.529-10.419 5.162-30.802-11.134-30.802h-76.344c-4.41 0-6.979-4.982-4.42-8.575l101.427-142.422c8.21-11.528-.032-27.515-14.184-27.515h-49.406c-4.12 0-6.737-4.41-4.763-8.027l51.184-93.772c6.178-11.321-8.371-22.498-17.717-13.611z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m282.203 254.182 29.111-40.876-81.858-81.858c-.322-1.317-1.465-2.421-3.068-2.421h-34.428l-4.94 4.698c-.459.436-.875.89-1.273 1.351-.106.124-.209.248-.311.374-.328.402-.636.811-.92 1.228-.05.073-.105.143-.153.217-.319.484-.604.979-.866 1.48-.066.126-.126.253-.188.38-.206.419-.393.842-.561 1.269-.043.108-.09.215-.13.324-.192.521-.357 1.047-.495 1.577-.026.101-.046.202-.07.303-.11.457-.2.916-.271 1.377-.018.114-.037.228-.052.342-.073.551-.125 1.103-.144 1.655-.001.027 0 .054 0 .081-.016.531-.003 1.062.03 1.59.006.094.012.188.019.281.088 1.127.282 2.242.581 3.327.015.054.031.109.046.163.319 1.12.743 2.209 1.272 3.246.001.002.002.004.003.005 1.087 2.129 2.599 4.045 4.473 5.586.011.014.024.025.035.039 2.886 2.36 6.62 3.837 10.976 3.837h41.532c4.51 0 7.051 5.181 4.292 8.748l-19.3 24.94c-.001-.001 56.292 56.366 56.658 56.737z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m203.021 51.362-106.386 108.151c-1.963 1.995-.549 5.368 2.25 5.368h44.019c2.429 0 3.947 2.629 2.733 4.733l-50.461 87.432c-1.837 3.183 2.327 6.404 4.946 3.826l128.48-126.441c2.012-1.98.61-5.405-2.213-5.405h-52.526c-2.382 0-3.905-2.539-2.784-4.641l36.976-69.326c1.714-3.213-2.48-6.294-5.034-3.697z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m134.814 506.567 214.804-178.629c12.53-10.419 5.162-30.802-11.134-30.802h-76.344c-4.41 0-6.979-4.982-4.42-8.574l101.427-142.422c8.21-11.528-.032-27.515-14.184-27.515h-49.407c-4.12 0-6.737-4.41-4.763-8.027l51.184-93.772c3.067-5.618 1.025-11.199-2.95-14.311l-107.091 124.372c-5.937 6.895-1.038 17.577 8.061 17.577h47.7c8.821 0 13.809 10.119 8.437 17.115l-113.941 148.386c-5.372 6.996-.384 17.115 8.437 17.115h67.144c9.31 0 14.127 11.114 7.763 17.908l-150.229 160.392c4.738 4.964 12.816 6.751 19.506 1.187z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m351.276 302.69c-1.12-1.23-2.427-2.305-3.896-3.176-.057-.034-.116-.067-.174-.1-.427-.246-.868-.474-1.322-.684-.067-.031-.132-.064-.2-.095-1.001-.447-2.067-.8-3.189-1.053-.15-.034-.303-.062-.455-.092-.418-.083-.843-.149-1.276-.203-.166-.02-.33-.043-.497-.059-.582-.055-1.174-.092-1.782-.092h-12.952l-43.17 43.887c-1.551 1.576-.989 4.006.693 4.96l20.37 20.37 46.193-38.414c8.403-6.989 7.846-18.453 1.657-25.249z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m388.747 232.872-106.385 108.151c-1.963 1.995-.549 5.368 2.25 5.368h44.019c2.429 0 3.947 2.629 2.733 4.733l-50.461 87.432c-1.837 3.183 2.327 6.404 4.946 3.826l128.48-126.441c2.012-1.98.61-5.405-2.213-5.405h-52.526c-2.382 0-3.905-2.539-2.784-4.641l36.976-69.326c1.713-3.213-2.48-6.294-5.035-3.697z",
    fill: "url(#SVGID_6_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.60cae5be3c7b316709925bdd519d4986.svg";
export { ForwardRef as ReactComponent };